import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'
import LineWarningIcon from 'LuxKit/Icons/line/LineExclamationCircleIcon'
import LineInfoIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'

export const successIcon = <LineCheckCircleIcon />
export const warningIcon = <LineWarningIcon />
export const infoIcon = <LineInfoIcon />

export const successSnackbar = (description: string) => {
  showSnackbar(description, 'success', { icon: successIcon })
}

export const errorSnackbar = (description: string) => {
  showSnackbar(description, 'critical')
}

export const warningSnackbar = (description: string) => {
  showSnackbar(description, 'warning', { icon: warningIcon })
}

export const infoSnackbar = (description: string) => {
  showSnackbar(description, 'neutral', { icon: infoIcon })
}
